import * as React from "react";
import { FC } from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { TitleReleaseType } from "./Constant/Source";
import ReleaseTypeCreateForm from "./Forms/ReleaseTypeCreateForm";

const ReleaseTypeCreate: FC<CreateProps> = props => {
  return (
    <Create {...props} title={TitleReleaseType.create}>
      <SimpleForm>
        <ReleaseTypeCreateForm />
      </SimpleForm>
    </Create>
  );
};

export default ReleaseTypeCreate;
